import React from 'react';
import { MoreBtn } from '@/components'
import { Link } from 'react-router-dom'

class news extends React.PureComponent {
  constructor() {
    super()
    this.state = {
      ecosphereImages: [
        {
          imgPath: require("img/pic21.png"),
          imgHDPath: `${require("img/pic21.png")} 1x,${require("img/pic21@2x.png")} 2x,${require("img/pic21@3x.png")} 3x`,
          title: 'BIM应用咨询',
          desc: '以自主研发BIM管理平台为基础， 提供企业BIM整体咨询解决方案及服务，为建设单位、施工企业、咨询企业等单位的各个工程领域项目打造全过程BIM应用体系',
          link: '/Products/EcosphereDetails/BIM'
        },
        {
          imgPath: require("img/pic22.png"),
          imgHDPath: `${require("img/pic22.png")} 1x,${require("img/pic22@2x.png")} 2x,${require("img/pic22@3x.png")} 3x`,
          title: '工程造价标准化作业',
          desc: '标准化工程造价通过组织创新、流程创新、技术创新，以信息化、大数据为背景，凭借标准化思维与人工智能 ，借鉴丰富的实操经验，将招标采购风险防患于未然。',
          link: '/Products/EcosphereDetails/Metering'
        },
        {
          imgPath: require("img/pic23.png"),
          imgHDPath: `${require("img/pic23.png")} 1x,${require("img/pic23@2x.png")} 2x,${require("img/pic23@3x.png")} 3x`,
          title: '建设工程大数据',
          desc: '青矩致力于建筑行业信息化、大数据以及数据智能化研究，利用云计算、大数据、NLP、机器学习等技术， 构建高内聚、低耦合、可交换的建筑行业信息化体系， 充分采集和挖掘信息化产生的数据， 通过业务建模、数据智能使数据产生最大价值，使信息化发挥最大效应。',
          link: '/Products/EcosphereDetails/Information'
        },
        {
          imgPath: require("img/pic24.png"),
          imgHDPath: `${require("img/pic24.png")} 1x,${require("img/pic24@2x.png")} 2x,${require("img/pic24@3x.png")} 3x`,
          title: '知识分享',
          desc: '面向建筑行业职场人士，提供BIM、造价与招采管理、工程审计等岗位技能培训，提升专业能力，满足执业需企业、咨询企业等单位的各个工程领域项目打造全过程BIM应用体系',
          link: '/Products/EcosphereDetails/Train'
        },
      ],
    }
  }
  render() {
    return (
      <section className="ecosphere">
        <h4 className="title">
          <Link to="/Products/EcosphereDetails/BIM">工程科技服务生态圈</Link>
        </h4>
        <ul>
          {
            this.state.ecosphereImages.map((item, index) =>
              <li key={index}>
                <Link to={item.link}>
                  <img src={item.imgPath} alt="" srcSet={item.imgHDPath} />
                  <div>
                    <h5>{item.title}</h5>
                    <p>{item.desc}</p>
                  </div>
                </Link>
              </li>
            )
          }
        </ul>
        <div style={{ padding: '19px 0 25px' }}>
          <MoreBtn link={'/Products/EcosphereDetails/BIM'} />
        </div>
      </section>
    );
  }
}

export default news;
